export class CommonMapSearchValues {
  public static SEARCH_ATTRIBUTE_CHARITY_FOCUSES = 'CharityFocuses';
  public static SEARCH_ATTRIBUTE_DISEASES = 'Diseases';
  public static SEARCH_ATTRIBUTE_GEO_BOUNDING_BOX = 'Geo Bounding Box';
  public static SEARCH_ATTRIBUTE_LOCATION_LITERAL = 'Location Literal';
  public static SEARCH_ATTRIBUTE_GEO_TILE_GRID = 'geotile_grid';
  public static SEARCH_ATTRIBUTE_LOCATION = 'Location';
  public static SEARCH_ATTRIBUTE_RADIUS = 'Radius';
  public static SEARCH_ATTRIBUTE_SEARCH_ITEMS = 'Search Items';
  public static SEARCH_ATTRIBUTE_SEARCH_QUERY = 'Search Query';
  public static SEARCH_ATTRIBUTE_SPECIALITIES = 'Specialities';
  public static SEARCH_ATTRIBUTE_EXCLUDE_LOCATION = 'Exclude Empty Location';

  public static SEARCH_ATTRIBUTE_QUERY_MODE = 'Query Mode';

  public static SORT_ATTRIBUTE_DISPLAY_NAME = 'Display Name';
  public static SORT_ATTRIBUTE_CREATED = 'Created';
  public static SORT_ATTRIBUTE_SCORE = 'Score';

  public static SEARCH_ATTRIBUTE_SEARCH_EXCLUSION = 'Search Exclusion';
}
